let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("87sWq")).then(() => parcelRequire('8uqvB'));